import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const getMVNJob = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/v3/mvn-job",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};